function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 4.86,
    height: 5.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.43,
    y: 2.695
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5.39,
    width: 4.86,
    height: 16.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.43,
    y: 13.875
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22.36,
    width: 4.86,
    height: 37.65,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.9720000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.43,
    y: 41.185
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 60.01,
    width: 4.86,
    height: 40.17,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.215
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.43,
    y: 80.095
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 100.18,
    width: 4.86,
    height: 51.37,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.43,
    y: 125.86500000000001
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 151.55,
    width: 4.86,
    height: 53.27,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.6942857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.43,
    y: 178.185
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 204.83,
    width: 4.86,
    height: 71.82,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.215
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.43,
    y: 240.74
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 276.65,
    width: 4.86,
    height: 74.2,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.6075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.43,
    y: 313.75
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 350.85,
    width: 4.86,
    height: 76.22,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.54
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.43,
    y: 388.96000000000004
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 427.07,
    width: 4.86,
    height: 80.05,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.9720000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.43,
    y: 467.09499999999997
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 507.13,
    width: 4.86,
    height: 95.59,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.43,
    y: 554.925
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 602.71,
    width: 4.86,
    height: 97.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.43,
    y: 651.355
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.86,
    y: 0,
    width: 35.33,
    height: 19.56,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.525,
    y: 9.78
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.19,
    y: 0,
    width: 36.85,
    height: 19.56,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.614999999999995,
    y: 9.78
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.04,
    y: 0,
    width: 38.45,
    height: 19.56,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.956
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 96.26500000000001,
    y: 9.78
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.49,
    y: 0,
    width: 43.13,
    height: 19.56,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1733333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.055,
    y: 9.78
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 158.62,
    y: 0,
    width: 45.28,
    height: 19.56,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 181.26,
    y: 9.78
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.9,
    y: 0,
    width: 47.65,
    height: 19.56,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 227.725,
    y: 9.78
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 251.54,
    y: 0,
    width: 47.79,
    height: 19.56,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.435,
    y: 9.78
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.34,
    y: 0,
    width: 54.21,
    height: 19.56,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.445,
    y: 9.78
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 353.55,
    y: 0,
    width: 60.69,
    height: 19.56,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 383.895,
    y: 9.78
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 414.24,
    y: 0,
    width: 64.74,
    height: 19.56,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.912
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.61,
    y: 9.78
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478.97,
    y: 0,
    width: 66.11,
    height: 19.56,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 512.025,
    y: 9.78
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 545.09,
    y: 0,
    width: 76.3,
    height: 19.56,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 583.24,
    y: 9.78
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 621.38,
    y: 0,
    width: 78.62,
    height: 19.56,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1733333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.69,
    y: 9.78
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.86,
    y: 19.56,
    width: 60.02,
    height: 35.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.891666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.870000000000005,
    y: 37.235
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.86,
    y: 54.9,
    width: 60.02,
    height: 37.53,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.255
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.870000000000005,
    y: 73.66499999999999
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.86,
    y: 92.44,
    width: 60.02,
    height: 38.51,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.6275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.870000000000005,
    y: 111.695
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.86,
    y: 130.94,
    width: 60.02,
    height: 41.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.20875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.870000000000005,
    y: 151.775
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.86,
    y: 172.61,
    width: 60.02,
    height: 45.74,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.435
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.870000000000005,
    y: 195.48000000000002
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.86,
    y: 218.35,
    width: 60.02,
    height: 49.54,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.256666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.870000000000005,
    y: 243.12
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.86,
    y: 267.89,
    width: 60.02,
    height: 53.7,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.966666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.870000000000005,
    y: 294.74
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.86,
    y: 321.59,
    width: 60.02,
    height: 62.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.004000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.870000000000005,
    y: 352.755
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.86,
    y: 383.91,
    width: 60.02,
    height: 66.87,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.003333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.870000000000005,
    y: 417.345
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.86,
    y: 450.78,
    width: 60.02,
    height: 80.66,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.002000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.870000000000005,
    y: 491.10999999999996
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.86,
    y: 531.44,
    width: 60.02,
    height: 81.06,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.001333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.870000000000005,
    y: 571.97
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.86,
    y: 612.5,
    width: 60.02,
    height: 87.5,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.5025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.870000000000005,
    y: 656.25
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.89,
    y: 19.56,
    width: 62.22,
    height: 84.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 96,
    y: 61.86
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.1,
    y: 19.56,
    width: 65.05,
    height: 84.6,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.01
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 159.625,
    y: 61.86
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 192.15,
    y: 19.56,
    width: 67.75,
    height: 84.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 226.025,
    y: 61.86
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.9,
    y: 19.56,
    width: 69.58,
    height: 84.6,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.596666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 294.69,
    y: 61.86
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.48,
    y: 19.56,
    width: 81.85,
    height: 84.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.296153846153846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.40500000000003,
    y: 61.86
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 411.33,
    y: 19.56,
    width: 88.33,
    height: 84.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.6909090909090905
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 455.495,
    y: 61.86
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.66,
    y: 19.56,
    width: 96.29,
    height: 84.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 547.8050000000001,
    y: 61.86
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 595.95,
    y: 19.56,
    width: 104.05,
    height: 84.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.1
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 647.975,
    y: 61.86
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.89,
    y: 104.16,
    width: 109.8,
    height: 89.87,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.978333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.78999999999999,
    y: 149.095
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.89,
    y: 194.03,
    width: 109.8,
    height: 105.56,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.72888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.78999999999999,
    y: 246.81
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.89,
    y: 299.58,
    width: 109.8,
    height: 115.04,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.685714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.78999999999999,
    y: 357.09999999999997
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.89,
    y: 414.62,
    width: 109.8,
    height: 130.14,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.446153846153846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.78999999999999,
    y: 479.69
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.89,
    y: 544.76,
    width: 109.8,
    height: 155.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.78999999999999,
    y: 622.38
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.69,
    y: 104.16,
    width: 123.75,
    height: 155.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.565,
    y: 182.075
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.44,
    y: 104.16,
    width: 129.36,
    height: 155.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.373333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 363.12,
    y: 182.075
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.8,
    y: 104.16,
    width: 130.44,
    height: 155.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.317142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 493.02,
    y: 182.075
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 558.25,
    y: 104.16,
    width: 141.75,
    height: 155.83,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 629.125,
    y: 182.075
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.69,
    y: 259.99,
    width: 153.01,
    height: 160.07,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.909999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 251.195,
    y: 340.025
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.69,
    y: 420.05,
    width: 153.01,
    height: 279.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.00111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 251.195,
    y: 560.025
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 259.99,
    width: 372.3,
    height: 116.53,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.421666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.85,
    y: 318.255
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 376.52,
    width: 372.3,
    height: 323.48,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 29.40727272727273
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.85,
    y: 538.26
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2000);
export default __webpack_public_path__ + "static/media/2000.eb568ef40882fed68dce118e6efbb360.svg";
export { ForwardRef as ReactComponent };